import {
  GetProgramGenresSuccessResponseSchema,
  ProgramGenreResponseSchema,
} from '@mntn/api-contracts/seller/v1/program-genres'
import { Actors as A, Tenants as T } from '@mntn/auth-types'
import { ErrorSchema as E, ErrorResponseSchema } from '@mntn/result'
import { z } from 'zod'

export { ProgramGenreResponseSchema }

export const GetProgramGenresResponseSchema = {
  200: GetProgramGenresSuccessResponseSchema,
  403: ErrorResponseSchema,
  500: E('PROGRAM_GENRES_QUERY_DB_ERROR'),
}

export const GetProgramGenresRequestSchema = z.object({
  principal: T.KindSchema(['advertiser', 'none']).and(A.UserSchema),
})
